import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_AIOLI = `${URL_RETAILER_SCOPED}/insight-assistant`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'aioli'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  aioli: URL_AIOLI,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
